import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { MODAL_CONFIRM_DISCARD_CHANGES, userRoles } from '../constants/constants';
import {
  deleteCase,
  caseSelect,
  createCase,
  displayWrapper,
  casePartSelect,
  showConfirmModal, flagGeneral, flagCaseLevel, flagSpecimen,
  createCasePreFilledDataByPatientIdentifier,
} from '../redux/actions';
import { InboxList, WithRole } from '../components';
import Search from '../components/inbox/Search';
import Sort from '../components/inbox/Sort';
import sortCases from '../helpers/sort';
import ShowArchivedBox from '../components/inbox/ShowArchivedBox';
import Chevron from '../assets/images/chevron.svg';
import CreateNewCase from '../components/modals/CreateNewCase';

class Inbox extends PureComponent {




  constructor(props) {
    super(props);

    this.state = {
      searchValue: '',
      sortValue: 3,
      cases: [],
      casesFiltered: [],
      status: 'expanded',
      displayArchived: false,
      inboxExpandedClassName: 'sidebar',
      inboxExpandedButton: 'sidebar__button-collapse',
      inboxCollapsedClassName: 'sidebar__collapsed-hidden',
      inboxContainerClassName: '',

    };

    this.addListenerToWindow();
  }

  componentWillReceiveProps(nextProps) {
    const cases = sortCases(nextProps.cases, this.state.sortValue);
    this.setState({ cases });
  }

  componentDidUpdate() {
    if (this.props.displayWrapper === true) {
      this.props.displayWrapper();
    }
  }

  addListenerToWindow = () => {
    window.onbeforeunload = () => {
      if (this.checkIfChangesHasBeenMade()) {
        return true;
      }
    }
  };

  handleSearchInputChange = (e) => {
    const searchValue = e.target.value;
    const casesFiltered = this.state.cases.filter(c => {
      if (!c.partOneGeneralInformation) {
        return null;
      }

      const fName = c.partOneGeneralInformation.firstName || '';
      const lName = c.partOneGeneralInformation.lastName || '';
      const fullName = fName + lName;

      return fullName.toLowerCase().includes(searchValue.toLowerCase());
    });

    this.setState({ searchValue, casesFiltered });
  };

  handleCaseSelected = (_case) => {
    // we dont need to reload selectedCase
    if (_case.id === this.props.selectedCase.id) return;

    if (this.props.selectedCase.id) {
      const changesHasBeenMade = this.checkIfChangesHasBeenMade();
      const isNewCase = !!this.props.newCaseId;

      if (changesHasBeenMade || isNewCase) {
        this.props.showConfirmModal(MODAL_CONFIRM_DISCARD_CHANGES, {
          onConfirm: () => {
            if (isNewCase) {
              this.props.deleteCase(this.props.selectedCase);
            }
            this.selectCase(_case);
          },
        });
      } else {
        this.selectCase(_case);
      }
    } else {
      this.selectCase(_case);
    }
  };

  selectCase = (_case) => {
    this.props.caseSelect(_case, this.props.user);
    this.props.displayWrapper();
    setTimeout(() => {
      this.props.displayWrapper();
    }, 100);
  };

  handleSortChange = (event, index) => {
    const sortValue = event.target.value;
    let casesSorted = [];

    if (this.state.searchValue.length) {
      casesSorted = sortCases(this.state.casesFiltered, sortValue);
      this.setState({ casesFiltered: casesSorted, sortValue });
    } else {
      casesSorted = sortCases(this.state.cases, sortValue);
      this.setState({ cases: casesSorted, sortValue });
    }
  };

  toggleDisplayArchived = () => {
    if (this.state.displayArchived === true) {
      this.setState({ displayArchived: false });
    } else {
      this.setState({ displayArchived: true });
    }
  };

  //Changes the className to handle the collapse animation of the inbox. 
  //The styling can be found in _sidebar.scss
  //collapses sidebar
  handleCollapse = () => {
    if (this.state.inboxExpandedClassName === 'sidebar') {
      this.setState({
        inboxExpandedClassName: 'sidebar-hidden',
        inboxExpandedButton: 'sidebar__button-collapse-hidden',
        inboxCollapsedClassName: 'sidebar__collapsed',
        inboxContainerClassName: 'sidebar__collapse-container',
      });
      this.props.handleMainCollapse(); //changes the class on main
    }
    //Expands sidebar
    else {
      this.setState({
        inboxExpandedClassName: 'sidebar',
        inboxExpandedButton: 'sidebar__button-collapse',
        inboxCollapsedClassName: 'sidebar__collapsed-hidden',
        inboxContainerClassName: '',
      });
      this.props.handleMainCollapse(); //changes the class on main
    }
  }


  checkIfChangesHasBeenMade = () => {
    const forms = Object.values(this.props.form);

    let changesHaveBeenMade;

    const newlyAddedValuesButNoInitial = forms
      .some(item => item.values && !item.initial);

    const valuesExistedAndAreChanged = forms
      .filter(item => item.values && item.initial)
      .some(item => !_.isEqual(item.values, item.initial));

    if (newlyAddedValuesButNoInitial || valuesExistedAndAreChanged) {
      changesHaveBeenMade = true;
    }

    this.props.specimens.forEach(specimen => {
      specimen.analyses.forEach(analysis =>
        analysis.hasUnsavedChanges ? changesHaveBeenMade = true : null);
    });

    this.props.selectedCase.analyses.forEach(analysis =>
      analysis.hasUnsavedChanges ? changesHaveBeenMade = true : null);

    (this.props.selectedCase.generalHasChanged) && (changesHaveBeenMade = true);
    (this.props._case.tableHasChanged) && (changesHaveBeenMade = true);

    // Checks if the temporary storage of assignments is empty or not
    (this.props._case.pathologistsToAssign.length > 0) && (changesHaveBeenMade = true);

    (this.props._case.pathologistsToUnassign.length > 0) && (changesHaveBeenMade = true);

    return changesHaveBeenMade;
  };

  render() {
    const {
      handleMainCollapse,
      selectedCase,
      user,
    } = this.props;
    const cases = this.state.cases ? this.state.cases : [];

    let displayedCases = this.state.searchValue.length ? this.state.casesFiltered : cases;

    if (!this.state.casesFiltered.length && this.state.searchValue.length) {
      displayedCases = [];
    }

    return (
      <>
        <div className={this.state.inboxContainerClassName}>
          {/* Expanded index sidebar*/}
          <div className={this.state.inboxExpandedClassName}>
            
            <WithRole
              render={(role) => (
                (role === userRoles.admin || role === userRoles.surgeon) && (
                  <Search
                    handleInputChange={this.handleSearchInputChange}
                    searchValue={this.state.searchValue}
                  />
                )
              )}
            />

            {/*Makes it possible for only admin to see archived cases checkbox and access archived cases*/}
            <WithRole
              render={(role) => (
                (role === userRoles.admin || role === userRoles.surgeon) && (
                  <ShowArchivedBox
                    displayArchived={this.state.displayArchived}
                    handleCheck={this.toggleDisplayArchived}
                  />
                )
              )}
            />


            <WithRole
              render={(role) => (
                (role === userRoles.admin || role === userRoles.surgeon) && (
                  <Sort
                    value={this.state.sortValue}
                    onChange={this.handleSortChange}
                  />
                  )
                )}
              />

            <InboxList

              displayArchived={this.state.displayArchived}
              cases={displayedCases}
              selectedCaseId={selectedCase.id}
              handleCaseSelected={this.handleCaseSelected}
              handleCollapse={this.handleCollapse}
              handleMainCollapse={handleMainCollapse}
            />

            {(user.role === userRoles.admin || user.role === userRoles.surgeon) && <CreateNewCase />}
          </div>

          <div
            className={this.state.inboxExpandedButton}
            onClick={() => { this.handleCollapse(); handleMainCollapse(); }}
          >
            <div>
              <img src={Chevron} className="sidebar__button-collapse-icon" alt="Expand inbox icon" />
            </div>
          </div>
        </div>


        {/* Collapsed index sidebar*/}
        <div className={this.state.inboxCollapsedClassName} onClick={() => { this.handleCollapse(); handleMainCollapse(); }}>
          <img src={Chevron} className="sidebar__collapsed-icon" alt="Collapse inbox icon" />
        </div>

      </>
    );
  }
}

const mapStateToProps = ({ _case, form, auth }) => {
  const { selectedCase, cases, caseClicked, specimens, casePartSelected, selectedSpecimen } = _case;
  const { user } = auth;
  return {
    user,
    userId: user.userId,
    cases,
    selectedCase,
    form,
    caseClicked,
    specimens,
    casePartSelected,
    selectedSpecimen,
    _case,
    userRole: user.email
  };
};

Inbox.propTypes = {
  cases: PropTypes.array.isRequired,
  selectedCase: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    specimens: PropTypes.array,
  }).isRequired,
  caseSelect: PropTypes.func.isRequired,
  createCase: PropTypes.func.isRequired,
  displayWrapper: PropTypes.func.isRequired
};

export default connect(mapStateToProps, {
  deleteCase,
  caseSelect,
  createCase,
  createCasePreFilledDataByPatientIdentifier,
  displayWrapper,
  casePartSelect,
  showConfirmModal,
  flagGeneral,
  flagCaseLevel,
  flagSpecimen,
})(Inbox);

